module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/gorizia.575c88247821c73928753dcebedbefdc.jpg";